module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Gestión de permisos aprobados")]), _c('p'), _c('transition-group', {
    staticClass: "contenedor-box",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(_vm.mostrarListaSolicitudesPorAprobar) ? _c('div', {
    key: "lista_solicitud_por_aprobar",
    staticClass: "box position-relative"
  }, [_c('lista-solicitud-permisos-por-aprobar', {
    on: {
      "close": function($event) {
        _vm.mostrarListaSolicitudesPorAprobar = false
      }
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08d50790","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Permisos_Por_Aprobar_RRHH.vue
// module id = 813
// module chunks = 0